import React from 'react';

export default function SupportSkeleton({ count = 4 }) {
    return (
        <div className="flex flex-col items-start justify-start w-full lg:h-[calc(100vh-10rem)] h-[80vh] overflow-y-auto animate-pulse">
            <div className="flex justify-start ms-4 lg:ms-0 mb-5 gap-3">
                <div className="h-[35px] w-full sm:w-[150px] bg-gray-300 rounded-full" />
                <div className="h-[35px] w-full sm:w-[150px] bg-gray-300 rounded-full" />
            </div>

            <div className="w-full">
                {Array.from({ length: count }).map((_, i) => (
                    <div key={i} className="flex flex-col w-full border-b border-gray-300 py-5" dir="rtl">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3">
                            <div className="flex items-center gap-3">
                                <div className="h-5 w-56 bg-gray-300 rounded" />
                            </div>
                            <div className="h-4 w-28 bg-gray-300 rounded mt-1 sm:mt-0" />
                        </div>

                        <div className="mt-2 flex">
                            <div className="h-[35px] w-full sm:w-[150px] bg-gray-300 rounded-xl" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
